module.exports = __webpack_public_path__ + "static/ron5-79279e43eaeb43ad139a3d75d19cb75b.jpg";